<!-- ng-block-ui custom HTML block component -->
<div class="block-ui-template text-center">
  <div class="spinner-border text-light" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
